import React, { useState } from 'react';

function Footer() {
  const [modal, setModal] = useState(null);
  const currentYear = new Date().getFullYear();

  const modalContent = {
    privacy: {
      title: 'Privacy Policy',
      body: `We respect your privacy. All data is processed securely and in compliance with GDPR and other applicable regulations. No personal data is shared with third parties without explicit consent.`
    },
    terms: {
      title: 'Terms of Service',
      body: `By using this platform, you agree to our terms of service. All AI insights are for informational purposes only and not a substitute for professional medical advice.`
    },
    security: {
      title: 'Security',
      body: `We use industry-standard encryption and security practices to protect your data. Our infrastructure is regularly audited and monitored for vulnerabilities.`
    }
  };

  return (
    <footer style={{ 
      background: '#1a202c',
      color: 'white',
      padding: '64px 24px 36px',
      marginTop: '80px',
      position: 'relative'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        position: 'relative',
        zIndex: 1
      }}>
        {/* Main footer content */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: '32px',
          marginBottom: '36px'
        }}>
          {/* Company info */}
          <div style={{ animation: 'slideInLeft 0.8s ease-out' }}>
            <div style={{
              fontSize: '1.6rem',
              fontWeight: '600',
              color: 'white',
              marginBottom: '20px',
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              <img 
                src="/dabra_logo.png" 
                alt="Dabra Logo" 
                style={{ height: '28px', width: 'auto', filter: 'brightness(0) invert(1)' }}
              />
              Dabra
            </div>
            <p style={{
              color: '#cbd5e0',
              lineHeight: '1.6',
              marginBottom: '20px',
              fontSize: '0.95rem'
            }}>
              Applied AI and automation studio helping teams transform complex data into measurable outcomes.
              We build compliant, production-ready solutions with a research-first mindset.
            </p>
          </div>
          
          {/* Solutions links */}
          <div style={{ animation: 'slideInUp 0.8s ease-out 0.2s both' }}>
            <h4 style={{
              fontSize: '1.1rem',
              fontWeight: '600',
              marginBottom: '20px',
              color: 'white'
            }}>
              Solutions
            </h4>
            {[
              'AI Automation Pipelines',
              'Healthcare Analytics & Wearables', 
              'Consultancy & Strategic Partnerships',
              'Research to Production Delivery'
            ].map((item, index) => (
              <div key={item} style={{
                marginBottom: '10px',
                color: '#cbd5e0',
                fontSize: '0.9rem',
                animation: `slideInUp 0.6s ease-out ${0.3 + index * 0.1}s both`,
                fontWeight: 500
              }}>
                {item}
              </div>
            ))}
          </div>
          
          {/* Contact info */}
          <div style={{ animation: 'slideInRight 0.8s ease-out 0.4s both' }}>
            <h4 style={{
              fontSize: '1.1rem',
              fontWeight: '600',
              marginBottom: '20px',
              color: 'white'
            }}>
              Contact
            </h4>
            <div style={{ marginBottom: '12px' }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                color: '#cbd5e0',
                fontSize: '0.9rem'
              }}>
                <span>📧</span>
                <span>dabra@dabra.tech</span>
              </div>
            </div>
            <div style={{ marginBottom: '15px' }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                color: '#cbd5e0',
                fontSize: '0.9rem'
              }}>
                <span>📞</span>
                <span>+420 606 208 251</span>
              </div>
            </div>
            
            <p style={{
              marginTop: '18px',
              fontSize: '0.85rem',
              color: '#94a3b8',
              lineHeight: '1.5'
            }}>
              We typically respond within 1-2 business days.
            </p>
          </div>
        </div>
        
        {/* Bottom bar */}
        <div style={{
          borderTop: '1px solid rgba(255, 255, 255, 0.1)',
          paddingTop: '30px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '20px',
          animation: 'slideInUp 0.8s ease-out 0.6s both'
        }}>
          <div style={{
            color: '#cbd5e0',
            fontSize: '0.85rem'
          }}>
            © {currentYear} Dabra s.r.o. All rights reserved.
          </div>
          
          <div style={{
            display: 'flex',
            gap: '25px',
            alignItems: 'center'
          }}>
            <span
              style={{
                color: '#cbd5e0',
                textDecoration: 'underline',
                fontSize: '0.85rem',
                cursor: 'pointer',
                transition: 'color 0.3s ease'
              }}
              onClick={() => setModal('privacy')}
            >
              Privacy Policy
            </span>
            <span
              style={{
                color: '#cbd5e0',
                textDecoration: 'underline',
                fontSize: '0.85rem',
                cursor: 'pointer',
                transition: 'color 0.3s ease'
              }}
              onClick={() => setModal('terms')}
            >
              Terms of Service
            </span>
            <span
              style={{
                color: '#cbd5e0',
                textDecoration: 'underline',
                fontSize: '0.85rem',
                cursor: 'pointer',
                transition: 'color 0.3s ease'
              }}
              onClick={() => setModal('security')}
            >
              Security
            </span>
          </div>
        </div>
      </div>
      {/* Modal for legal/security info */}
      {modal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(0,0,0,0.45)',
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
          onClick={() => setModal(null)}
        >
          <div
            style={{
              background: '#fff',
              color: '#2d3748',
              borderRadius: '12px',
              maxWidth: '420px',
              width: '90vw',
              padding: '36px 28px',
              boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
              position: 'relative',
              cursor: 'auto'
            }}
            onClick={e => e.stopPropagation()}
          >
            <h3 style={{
              fontSize: '1.2rem',
              fontWeight: 700,
              marginBottom: '18px',
              color: '#2d3748'
            }}>{modalContent[modal].title}</h3>
            <p style={{
              fontSize: '1rem',
              color: '#4a5568',
              marginBottom: 0,
              lineHeight: 1.7
            }}>{modalContent[modal].body}</p>
            <button
              onClick={() => setModal(null)}
              style={{
                marginTop: '28px',
                background: '#2d3748',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                padding: '10px 24px',
                fontSize: '1rem',
                cursor: 'pointer',
                float: 'right'
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </footer>
  );
}

export default Footer;
